import { SidebarFooter, useSidebar } from 'components/ui/sidebar';
import { UProfileMenu } from '../u-profile-menu';

export function AppSidebarFooter() {
  const { open, isSidebarOverlay } = useSidebar();
  const showExpanded = open || isSidebarOverlay;

  if (!showExpanded) {
    return (
      <SidebarFooter className="mt-auto w-full shrink-0 gap-2 !p-0 bg-transparent">
        <div className="flex justify-center">
          <UProfileMenu variant="avatar" />
        </div>
      </SidebarFooter>
    );
  }

  return (
    <SidebarFooter className="mt-auto w-full shrink-0 gap-2 !p-0 bg-transparent">
      <UProfileMenu variant="pill" isDropdownIconRequired isFullNameRequired />
    </SidebarFooter>
  );
}
